import { connect } from "react-redux"
import { Dispatch } from "redux"
import {
  resetEpisodes,
  updateEpisodes,
} from "../../actions/pages/tagActionCreator"
import { RootState, ReduxAction } from "../../reducers"
import { IRootPagesState } from "../../reducers/pages"
import { Episode } from "../../rpcs/dist/EpisodeRPC"

export interface IContainerProps {
  actions: ActionDispatcher
  episode: IRootPagesState["recentEpisode"]
}

export class ActionDispatcher {
  constructor(private dispatch: (action: ReduxAction) => void) {}

  public updateEpisodes(episode: Episode[]) {
    this.dispatch(updateEpisodes(episode))
  }

  public resetEpisode() {
    this.dispatch(resetEpisodes())
  }
}

const mapDispatchToProps = (dispatch: Dispatch<ReduxAction>) => ({
  actions: new ActionDispatcher(dispatch),
})

const mapStateToProps = ({ pages }: RootState) => ({
  episode: pages.tag,
})

export const container = connect(mapStateToProps, mapDispatchToProps)
